import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { DialogEventState } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-state.service';
import { DialogEventOverlay } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-overlay.enum';
import { DialogEventTabsService } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-tabs.service';
import { DialogEventHideConfService } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-hide-conf.service';

@Component({
  selector: 'gc-dialog-event-footer',
  standalone: true,
  imports: [TranslateDirective, Button, SvgIconComponent],
  templateUrl: './dialog-event-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class DialogEventFooterComponent {
  protected readonly dialogState = inject(DialogEventState);

  private readonly tabs = inject(DialogEventTabsService);
  private readonly hideConf = inject(DialogEventHideConfService);

  protected readonly isHidden = this.dialogState.isHidden;

  /** only hiding asks first, and only until `Don't show this message again`: putting an event back costs nothing to undo */
  protected toggleVisibility(): void {
    if (this.isHidden()) {
      this.dialogState.setHidden(false);

      return;
    }

    if (this.hideConf.isBlocked()) {
      this.dialogState.setHidden(true);

      return;
    }

    this.tabs.openOverlay(DialogEventOverlay.Hide);
  }
}
